import * as batshit from "@yornaath/batshit";
import api from "../../../api";
import {DiagramId, DiagramEvidenceId} from "platformed-client/types";
import {param, typedQuery} from "../../typing";
import {resolver, scheduler} from "../../batch";

export const diagram = typedQuery(["tprm", "diagram", param<DiagramId>("diagramId")], async diagramId => {
  return await api.tprm.diagrams.get(diagramId);
});

const diagramEvidencesById = batshit.create({
  fetcher: api.tprm.diagrams.loadDiagramEvidence,
  resolver: resolver("diagram_evidence_id"),
  scheduler,
});

export const diagramEvidenceById = typedQuery(
  ["tprm", "diagramEvidenceById", param<DiagramEvidenceId>("evidenceId")],
  async evidenceId => {
    return await diagramEvidencesById.fetch(evidenceId);
  },
);

export const diagramEvidence = typedQuery(
  ["tprm", "diagramEvidence", param<DiagramId>("diagramId")],
  async diagramId => {
    return await api.tprm.diagrams.listDiagramEvidence(diagramId);
  },
);
